import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueKonva from 'vue-konva'
import App from './App.vue'
import router from './router'
import { setRouter } from './router/instance'
import { useAuthStore } from './stores/auth'

import './style.css'
import 'vue-sonner/style.css'

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
	console.error('[Global Error]', err, info)
}

window.addEventListener('unhandledrejection', (event) => {
	console.error('[Unhandled Promise]', event.reason)
})

const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(VueKonva)
setRouter(router)

// Initialize user info if token exists
async function initAuth() {
	const authStore = useAuthStore()
	if (authStore.token) {
		try {
			await authStore.fetchUser()
		} catch (e) {
			console.error('Failed to fetch user info on init:', e)
		}
	}
}

initAuth().then(() => {
	app.mount('#app')
})
